'use client';

import { Variants, motion } from 'motion/react';
import { ReactNode } from 'react';

import { cn } from '@natu/utils/cn';

export type MarqueeDirection = 'left' | 'right';

export interface MarqueeProps {
  children?: ReactNode;
  className?: string;
  direction?: MarqueeDirection;
  transition?: number;
}

const MARQUEE_MULTIPLIER = 5;
const DEFAULT_TRANSITION = 1200;

const marqueeVariants: Variants = {
  whileInView: ({ direction, duration }) => ({
    x: direction === 'right' ? ['-100%', '0%'] : ['0%', '-100%'],
    transition: {
      duration,
      repeat: Infinity,
      ease: 'linear',
    },
  }),
};

const Marquee = ({ children, className, direction = 'left', transition }: MarqueeProps) => {
  const multiplicateContent = new Array(MARQUEE_MULTIPLIER).fill(children);
  const duration = ((transition || DEFAULT_TRANSITION) * MARQUEE_MULTIPLIER) / 1000;

  return (
    <motion.div className={cn('flex overflow-hidden', className)} whileInView="whileInView">
      {multiplicateContent.map((content, index) => (
        <motion.div
          key={encodeURI(`${content}${index}`)}
          custom={{ direction, duration }}
          variants={marqueeVariants}
        >
          {content}
        </motion.div>
      ))}
    </motion.div>
  );
};

export { Marquee };
